import { Typography } from "@suraasa/placebo-ui"
import { CircularProgress } from "@suraasa/placebo-ui"
import PageContainer from "components/PageContainer"
import { IS_LOCALHOST } from "utils/constants"

type Props = {
  message?: string
  debugMessage?: string
}

export default function FullPageLoading({ message = "", debugMessage }: Props) {
  return (
    <PageContainer className="h-screen">
      <div className="flex h-full flex-col items-center justify-center">
        <CircularProgress size="lg" color="black" />
        {message && (
          <Typography variant="largeBody" className="mt-1 text-center">
            {message}
          </Typography>
        )}
        {IS_LOCALHOST && debugMessage && (
          <Typography
            variant="smallBody"
            className="mx-auto mt-1 text-center text-critical-500"
          >
            DEBUG: {debugMessage}
          </Typography>
        )}
      </div>
    </PageContainer>
  )
}
